import React from 'react'
import styled from '@emotion/styled'
import { FilePreview } from '@ow/comps'
import { useDitto } from '@ow/ditto-core'
import { fileTypeImg } from '../../../utils/file-constants'
import {
  checkIsImage,
  getWatermarkUrl,
  checkFile,
  getType,
} from '../../../utils/media'

import deleteImg from '../assets/delete.png'
import downloadImg from '../assets/download.png'

const MediaItem = ({ files, item, index, deleteFile }) => {
  const Item = styled.div`
    width: 100px;
    height: 100px;
    .item-bottom {
      justify-content: ${deleteFile ? 'center' : 'space-between'};
    }
    &:hover .delete-icon {
      visibility: visible !important;
    }
  `

  const { src, filename } = item
  const extension = checkFile(src)
  const { key } = getType(extension)

  const { addWatermarkToImage } = useDitto()
  const getThumbnail = (url) => {
    if (url.indexOf('ow-prod.oss-') > -1 || url.indexOf('ow-prod-cdn') > -1) {
      const position = url.indexOf('?Expires=')
      return `${
        position === -1 ? url : url.slice(0, position)
      }?x-oss-process=image/resize,h_170,m_lfit`
    }
    return url
  }
  return (
    <Item
      className="flex flex-col items-center relative rounded-box"
      style={{
        fontSize: '.75rem',
        background: 'rgba(0, 0, 0, 0.03)',
        color: 'rgba(0, 0, 0, 0.45)',
      }}
    >
      {deleteFile && (
        <span
          onClick={() => {
            deleteFile(item, index)
          }}
          className="delete-icon visible md:invisible"
        >
          <img
            src={deleteImg}
            alt=""
            className="absolute -top-1.5 -right-1.5 text-red-2 cursor-pointer z-20 w-4 h-4"
          />
        </span>
      )}
      <div
        className="w-full"
        style={{ height: 'calc(100% - 1.375rem)' }}
        onClick={() => {
          FilePreview.preview(
            files.map((v) => {
              const isImage = checkIsImage(v)
              const link = v.src || v.link
              const endPosition = link.indexOf('?Expires=')
              const originSrc =
                endPosition === -1 ? link : link.slice(0, endPosition)
              if (v.waterMarkInfo) {
                const { originWatermarkUrl, thumbnailWatermarkUrl } =
                  getWatermarkUrl(
                    { originSrc, ...v },
                    addWatermarkToImage,
                    v.waterMarkInfo
                  )
                return {
                  ...v,
                  // data: rowData,
                  src: originSrc,
                  srcWatermark: isImage ? thumbnailWatermarkUrl : src,
                  originWatermarkUrl,
                }
              }
              return {
                ...v,
                // data: rowData,
                src: originSrc,
                srcWatermark: originSrc, // 冲突了，暂时保留闫俊的
                originWatermarkUrl: originSrc,
              }
            }),
            index
          )
        }}
      >
        <img
          src={
            key === 'image'
              ? getThumbnail(src)
              : fileTypeImg[extension] || fileTypeImg[key]
          }
          alt=""
          className="w-full h-full z-10"
          style={{
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
          }}
        />
      </div>

      <div
        className="item-bottom mt-1 w-full flex flex-row items-center"
        style={{
          padding: '0 .75rem',
        }}
      >
        <span
          title={filename}
          className="truncate"
          style={{ maxWidth: '20px' }}
        >
          {filename && filename.slice(0, filename.indexOf('.'))}
        </span>
        <span title={filename} className="truncate">
          .{extension}
        </span>
        {!deleteFile && (
          <a
            href={`${item.src}?response-content-type=application/octet-stream`}
            download={item.src}
          >
            <img src={downloadImg} alt="" className="w-3 h-3" />
          </a>
        )}
      </div>
    </Item>
  )
}

export default MediaItem
